import { Component, OnInit } from '@angular/core';
import { AppService } from '../../../services/app.service';
import { ITableColumn } from '../../../shared/table/table.component';
import { HealthMinistryService } from '../../../services/health-ministry.service';
import { IPersonData, IResidentDetails } from '../../../models/HealthMinistry';
import { ActivatedRoute } from '@angular/router';

const cache: {
    details: { [studentId: string]: IResidentDetails }
} = {
    details: {}
};

@Component({
    selector: 'app-health-ministry-dashboard-resident',
    templateUrl: './health-ministry-dashboard-resident.component.html'
})
export class HealthMinistryDashboardResidentComponent implements OnInit {
    constructor(
        private app: AppService,
        private service: HealthMinistryService,
        private route: ActivatedRoute
    ) { }

    id: string;
    data: IResidentDetails;
    person: IPersonData;
    activeTabId = 1;

    readonly statusColumns: ITableColumn[] = [
        { property: 'StatusName', label: 'healthMinistryDashboard_lblStatus' },
        { property: 'DateFrom', label: 'healthMinistryDashboard_lblDateFrom' },
        { property: 'DateTo', label: 'healthMinistryDashboard_lblDateTo' }
    ];

    readonly studyColumns: ITableColumn[] = [
        { property: 'StudyProgramName', label: 'healthMinistryDashboard_lblSpeciality' },
        { property: 'StudentStatusName', label: 'healthMinistryDashboard_lblStatus' },
        { property: 'Date', label: 'healthMinistryDashboard_lblDate' },
        { width: '1px' }
    ];

    readonly vacationColumns: ITableColumn[] = [
        { property: 'StudyYear', label: 'healthMinistryDashboard_lblStudyYear' },
        { property: 'DateFrom', label: 'healthMinistryDashboard_lblDateFrom' },
        { property: 'DateTo', label: 'healthMinistryDashboard_lblDateTo' },
        { property: 'Resumpted', label: 'healthMinistryDashboard_lblResumpted' }
    ];

    readonly workplaceColumns: ITableColumn[] = [
        { property: 'CompanyName', label: 'healthMinistryDashboard_lblWorkplace' },
        { property: 'DateFrom', label: 'healthMinistryDashboard_lblDateFrom' },
        { property: 'DateTo', label: 'healthMinistryDashboard_lblDateTo' }
    ];

    readonly clinicalBaseColumns: ITableColumn[] = [
        { property: 'CompanyName', label: 'healthMinistryDashboard_lblClinicalBase' },
        { property: 'DateFrom', label: 'healthMinistryDashboard_lblDateFrom' },
        { property: 'DateTo', label: 'healthMinistryDashboard_lblDateTo' }
    ];

    readonly studyTypeColumns: ITableColumn[] = [
        { property: 'StudyTypeName', label: 'healthMinistryDashboard_lblFinancing' },
        { property: 'DateFrom', label: 'healthMinistryDashboard_lblDateFrom' },
        { property: 'DateTo', label: 'healthMinistryDashboard_lblDateTo' }
    ];

    get undefinedString() {
        return this.person ? this._undefinedString : '';
    }

    private readonly tabs = {
        info: 1,
        breaks: 2,
        workplace: 3,
        financing: 4
    };

    private readonly _undefinedString = this.app.translate('undefined');

    ngOnInit() {
        const id = this.id = this.route.snapshot.params.id;

        let studentId: string;

        this.route.queryParams.subscribe(para => {
            let tab = (para.tab || '').toLowerCase();

            if (!this.tabs[tab]) tab = 'info';

            this.activeTabId = this.tabs[tab];

            studentId = para.StudentId;

            if (studentId) {
                this.person = this.data?.Person.find(t => t.StudentId.toLowerCase() == studentId.toLowerCase());
            }
        });

        const init = (data: IResidentDetails) => {
            this.data = cache.details[id] = data;
            this.person = data.Person.find(t => t.StudentId.toLowerCase() == (studentId || id).toLowerCase());
        };

        if (cache.details[id]) {
            init(cache.details[id]);
        } else {
            this.app.addLoading(this.service.getResident(id)).subscribe(data => {
                init(data);
            });
        }
    }
}
